import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './Redux/store'
import {Provider} from "react-redux";

window.conf_nofunc = false;
// window.conf_nofunc = true;
// if (window.innerWidth < 1024)
//     window.conf_noTouchFunc = true

var uri = window.location.search.substring(1);
var params = new URLSearchParams(uri);
window.debug = (params.get("debug")=='Y')?true:false;
window.speed = (params.get("speed")=='Y')?true:false;
window.grid = (params.get("grid")=='Y')?true:false;
// window.showroom = (params.get("showroom")=='N')?false:true;
window.showroom = false;
// window.grid = true

// window.debug = false;
// window.debug = true;

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
            <App />
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

